export const categories = [
  {
    slug: 'brand-news',
    name: '品牌动态',
    description: '了解问鼎.cc 最新品牌资讯、官方公告与发展动态',
    icon: 'ri-megaphone-line',
    count: 18,
  },
  {
    slug: 'industry-insight',
    name: '行业洞察',
    description: '深度解读行业趋势、政策变化与市场前沿信息',
    icon: 'ri-lightbulb-line',
    count: 24,
  },
  {
    slug: 'product-service',
    name: '产品服务',
    description: '探索问鼎.cc 核心产品功能、服务方案与使用指南',
    icon: 'ri-stack-line',
    count: 15,
  },
  {
    slug: 'tech-frontier',
    name: '技术前沿',
    description: '关注技术创新、安全防护与平台架构升级',
    icon: 'ri-cpu-line',
    count: 12,
  },
  {
    slug: 'customer-case',
    name: '客户案例',
    description: '真实客户成功故事，见证问鼎.cc 带来的价值',
    icon: 'ri-star-line',
    count: 9,
  },
];

export const categoryMap: Record<string, typeof categories[0]> = {};
categories.forEach((cat) => {
  categoryMap[cat.slug] = cat;
});